import './forms'
import './gallery'

window.addEventListener("DOMContentLoaded", () => {

	// --> start nav handle
	const hamburger = document.querySelector('.hamburger');
	hamburger.addEventListener('click', toggleMenu);

	const scrollHam = document.querySelector('.scrollnav .hamburger');
	scrollHam.addEventListener('click', toggleMenu);

	const mobile = document.querySelector('.mobile');

	const closeBtn = document.querySelector('.close');
	closeBtn.addEventListener('click', closeNav);

	//toggle mobile nav (hamburger) button
	let showed = false;
	function toggleMenu() {
		if (!showed) {
			mobile.classList.add('open');
			showed = true;
		} else {
			mobile.classList.remove('open');
			showed = false;
		}
	}

	//add active nav
	let url = window.location.href.split('/');
	let page = url[url.length - 2];
	let links = document.querySelectorAll(`[href='/${page}']`);
	if (links.length > 0) {
		for (let i = 0; i < links.length; i++) {
			links[i].classList.add('active');
			if (links[i].parentElement.classList.contains('dropdown')) {
				links[i].parentElement.parentElement.classList.add('active');
			}
			else {
				links[i].parentElement.classList.add('active');
			}
		}
	}

	// Nav slides down when user scrolls up
	let nav = document.querySelector('nav.scrollnav');
	let wrapper = document.querySelector('.page-wrapper');
	wrapper.addEventListener('scroll', function (e) {
		if (!nav.classList.contains('scrolling') && wrapper.scrollTop >= 200) {
			nav.classList.add('scrolling');
		}
		if (wrapper.scrollTop < 200) {
			nav.classList.remove('scrolling');
		}
	})

	//close mobile nav button handle
	function closeNav() {
		mobile.classList.remove('open');
		showed = false;
	}
	// close mobile nav when click out side of mobile nav container
	document.addEventListener('click', ev => {
		if (document.querySelector('.mobile.open')) {
			if (!ev.path.includes(document.querySelector('.mobile.open')) && !ev.path.includes(document.querySelector('.hamburger')) && !ev.path.includes(document.querySelector('.scrollnav .hamburger'))) {
				document.querySelector('nav.mobile').classList.remove('open');
				showed = false;
				console.log('here');
			}
		}
	});
	// <-- end nav handle

	//the team section handle (slide right to left when click)
	const theTeamSections = document.querySelectorAll('.the-team-section');
	theTeamSections.forEach(theTeamSection => {
		const slides = theTeamSection.querySelectorAll('.slide');
		const navs = theTeamSection.querySelectorAll('.nav');

		//set active for first slide
		slides[0].classList.add('active');
		navs[0].classList.add('active');
		let active_id = 0;
		//slides[0].style.transform = `scale(1) translate(0vw)`;
		navs.forEach(nav =>
			nav.addEventListener('click', e => {
				let clicked_nav_id = e.currentTarget.getAttribute('id').split('nav-')[1];
				//remove old active class
				navs[active_id].classList.remove('active');
				slides[active_id].classList.remove('active');
				slides[active_id].classList.add('inactive');

				//add new active class
				navs[clicked_nav_id].classList.add('active');
				slides[clicked_nav_id].classList.add('active');
				active_id = clicked_nav_id;
			})
		)
	});
});

document.addEventListener('DOMContentLoaded', function (e) {
	let circles = document.querySelectorAll('.number-block .circled .circle h5');
	for (let i = 0; i < circles.length; i++) {
		circles[i].setAttribute('style', `--tooltip-dimension: ${(circles[i].scrollWidth > circles[i].scrollHeight) ? circles[i].scrollWidth : circles[i].scrollHeight}px;`);
		circles[i].parentElement.setAttribute('style', `right: calc(-${(circles[i].scrollWidth > circles[i].scrollHeight) ? circles[i].scrollWidth / 2 : circles[i].scrollHeight / 2}px - 2rem);`);
	}

	window.addEventListener('resize', function (e) {
		for (let i = 0; i < circles.length; i++) {
			circles[i].setAttribute('style', `--tooltip-dimension: ${(circles[i].scrollWidth > circles[i].scrollHeight) ? circles[i].scrollWidth : circles[i].scrollHeight}px;`);
			circles[i].parentElement.setAttribute('style', `right: calc(-${(circles[i].scrollWidth > circles[i].scrollHeight) ? circles[i].scrollWidth / 2 : circles[i].scrollHeight / 2}px - 2rem);`);
		}
	})
})

// Pre-footer bar section
document.addEventListener('DOMContentLoaded', function (e) {
	let observer = new IntersectionObserver(toggleBar, { threshold: 1.0 });
	let stickypf = document.querySelector('div.pre-footer.sticky');
	let preFooter = document.querySelector('div.pre-footer:not(.sticky)');
	let closepf = stickypf.querySelector('button.close');

	let acsbButton = null;
	let time = 0;
	let getAcsbButton = setInterval(() => {
		acsbButton = document.querySelector('[data-acsb]:nth-of-type(3)')?.shadowRoot?.querySelector('button');
		if (acsbButton || time >= 10000) {
			clearInterval(getAcsbButton);
		} else {
			time += 50;
		}
	}, 50)

	if (preFooter && stickypf) {
		observer.observe(preFooter);
	}

	function toggleBar(entries) {
		entries.forEach(entry => {
			if (entry.intersectionRatio >= 1.0) {
				stickypf.style.display = "none";
			} else {
				stickypf.style.display = "block";
			}
		})
	}

	window.addEventListener('scroll', function (e) {
		if (window.scrollY >= 100 && !getLocalStorage('closedpf')) {
			stickypf.classList.add('show');
			if (acsbButton) {
				acsbButton.setAttribute('style', `--offset-top: ${stickypf.scrollHeight + 20}px;`);
			}
		} else {
			stickypf.classList.remove('show');
			if (acsbButton) {
				acsbButton.setAttribute('style', `--offset-top: 20px;`);
			}
		}
	})

	closepf.addEventListener('click', function (e) {
		stickypf.classList.remove('show');
		setLocalStorage('closedpf', 'true', 7);
	})

	function setLocalStorage(name, value, days) {
		if (days) {
			var now = new Date();
			var ttl = new Date();
			ttl.setTime(ttl.getTime() + (days * 24 * 60 * 60 * 1000));

			const item = {
				value: value,
				expiry: now.getTime() + ttl.toUTCString(),
			}

			localStorage.setItem(name, JSON.stringify(item));
		} else {
			localStorage.setItem(name, value);
		}
	}

	function getLocalStorage(name) {
		const itemStr = localStorage.getItem(name);
		// if the item doesn't exist, return null
		if (!itemStr) {
			return null;
		}
		const item = JSON.parse(itemStr);
		const now = new Date();
		// compare the expiry time of the item with the current time
		if (now.getTime() > item.expiry) {
			// If the item is expired, delete the item from storage
			// and return null
			localStorage.removeItem(name);
			return null;
		}
		return item.value;
	}
})